<template>
  <el-form
    :model="queryform"
    :rules="rules"
    ref="queryform"
    label-position="top"
  >
    <el-row>
      <!--      <el-col :span="8">-->
      <!--        <el-form-item label="发送配置标识" prop="s_config_defn">-->
      <!--          <el-input v-model="queryform.s_config_defn"></el-input>-->
      <!--        </el-form-item>-->
      <!--      </el-col>-->
      <el-col :span="12">
        <el-form-item label="接收用户身份(Receiverid)" prop="s_receiver_defn">
          <el-input v-model="queryform.s_receiver_defn"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="报文类型" prop="s_msg_type">
          <el-input v-model="queryform.s_msg_type"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <!-- 本地发送协议 -->
    <el-row style="display: flex;flex-wrap: wrap;">
      <el-col :span="12">
        <el-form-item
          label="本地发送协议"
          prop="s_sender_conn_uuid"
          class="lablebtn"
        >
          <template slot="label">
            <span>本地发送协议</span>
            <el-button
              icon="el-icon-fa-asterisk"
              type="primary"
              class="pull-right"
              @click="csSelectSenior(queryform.s_sender_conn_uuid)"
              title="高级选项"
              >高级</el-button
            >
          </template>
          <el-select
            v-model="queryform.s_sender_conn_uuid"
            filterable
            clearable
            placeholder="请选择"
            @change="csSelectChange(queryform.s_sender_conn_uuid)"
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.text"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <!-- csptdefn动态变化资源开始 -->
      <el-col :span="12" v-if="this.csptdefn === 'RocketMQ'">
        <el-form-item prop="recequeue" label="本地发送主题">
          <el-input v-model="queryform.recequeue"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.csptdefn === 'RocketMQ'">
        <el-form-item prop="recetag" label="本地发送标签">
          <el-input v-model="queryform.recetag"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.csptdefn === 'RocketMQ'">
        <el-form-item prop="consumerGroup" label="本地发送组名">
          <el-input v-model="queryform.consumerGroup"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.csptdefn === 'RMQ'">
        <el-form-item prop="recequeue" label="本地发送队列">
          <el-input v-model="queryform.recequeue"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.csptdefn === 'AMQ'">
        <el-form-item prop="recequeue" label="本地发送队列">
          <el-input v-model="queryform.recequeue"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.csptdefn === 'WMQ'">
        <el-form-item prop="recequeue" label="本地发送队列">
          <el-input v-model="queryform.recequeue"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.csptdefn === 'MSMQ'">
        <el-form-item prop="recequeue" label="本地发送队列">
          <el-input v-model="queryform.recequeue"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.csptdefn === 'DIR'">
        <el-form-item prop="recedir" label="本地发送文件夹">
          <el-input v-model="queryform.recedir"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="12" v-if="this.csptdefn === 'AS3'">
        <el-form-item prop="serverout" label="接收路径">
          <el-input v-model="queryform.csserverout"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.csptdefn === 'AS3'">
        <el-form-item prop="clientmdn" label="MDN回执路径">
          <el-input v-model="queryform.csclientmdn"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.csptdefn === 'AS3'">
        <el-form-item prop="clienttmp" label="临时路径">
          <el-input v-model="queryform.csclienttmp"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="12" v-if="this.csptdefn === 'AS2'">
        <el-form-item prop="reqpath" label="访问地址">
          <el-input v-model="queryform.reqpath"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.csptdefn === 'AS2'">
        <el-form-item prop="port" label="端口">
          <el-input v-model="queryform.port"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.csptdefn === 'AS2'">
        <el-form-item prop="threshold" label="阈值">
          <el-input v-model="queryform.threshold"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.csptdefn === 'FTP'">
        <el-form-item prop="recedir" label="本地发送文件夹">
          <el-input v-model="queryform.recedir"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.csptdefn === 'FTPS'">
        <el-form-item prop="recedir" label="本地发送文件夹">
          <el-input v-model="queryform.recedir"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.csptdefn === 'SFTP'">
        <el-form-item prop="recedir" label="本地发送文件夹">
          <el-input v-model="queryform.recedir"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.csptdefn === 'REST'">
        <el-form-item prop="port" label="端口">
          <el-input v-model="queryform.port"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.csptdefn === 'REST'">
        <el-form-item prop="reqpath" label="请求路径">
          <el-input v-model="queryform.reqpath"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.csptdefn === 'REST'">
        <el-form-item prop="cstoken" label="token">
          <el-input v-model="queryform.cstoken"></el-input>
        </el-form-item>
      </el-col>
      <!-- csptdefn动态变化资源结束 -->
      <!--      <el-col :span="12">-->
      <!--        <el-form-item prop="s_sender_res" label="本地发送配置">-->
      <!--          <el-input v-model="queryform.s_sender_res"></el-input>-->
      <!--        </el-form-item>-->
      <!--      </el-col>-->
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="责任链" prop="s_rc_uuid">
          <el-select
            v-model="queryform.s_rc_uuid"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in rpbOpt"
              :key="item.id"
              :label="item.text"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="过滤器" prop="s_cf_uuid">
          <el-select
            v-model="queryform.s_cf_uuid"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in routerOpt"
              :key="item.id"
              :label="item.text"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <!-- 传输发送协议 -->
    <el-row style="display: flex;flex-wrap: wrap;">
      <el-col :span="12">
        <el-form-item
          label="传输发送协议"
          prop="s_receiver_conn_uuid"
          class="lablebtn"
        >
          <template slot="label">
            <span>传输发送协议</span>
            <el-button
              icon="el-icon-fa-asterisk"
              type="primary"
              class="pull-right"
              @click="pdSelectSenior(queryform.s_receiver_conn_uuid)"
              title="高级选项"
              >高级</el-button
            >
          </template>
          <el-select
            v-model="queryform.s_receiver_conn_uuid"
            clearable
            filterable
            placeholder="请选择"
            @change="pdSelectChange(queryform.s_receiver_conn_uuid)"
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.text"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <!-- pdptdef动态变化资源开始 -->
      <el-col :span="12" v-if="this.pdptdefn === 'RMQ'">
        <el-form-item prop="sendqueue" label="传输发送队列">
          <el-input v-model="queryform.sendqueue"></el-input>
        </el-form-item>
      </el-col>


      <el-col :span="12" v-if="this.pdptdefn === 'AMQ'">
        <el-form-item prop="sendqueue" label="传输发送队列">
          <el-input v-model="queryform.sendqueue"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.pdptdefn === 'RocketMQ'">
        <el-form-item prop="producerGroup" label="传输发送组名">
          <el-input v-model="queryform.producerGroup"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.pdptdefn === 'RocketMQ'">
        <el-form-item prop="sendtag" label="传输发送标签">
          <el-input v-model="queryform.sendtag"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.pdptdefn === 'RocketMQ'">
        <el-form-item prop="sendqueue" label="传输发送主题">
          <el-input v-model="queryform.sendqueue"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.pdptdefn === 'WMQ'">
        <el-form-item prop="sendqueue" label="传输发送队列">
          <el-input v-model="queryform.sendqueue"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.pdptdefn === 'MSMQ'">
        <el-form-item prop="sendqueue" label="传输发送队列">
          <el-input v-model="queryform.sendqueue"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.pdptdefn === 'DIR'">
        <el-form-item prop="senddir" label="传输发送文件夹">
          <el-input v-model="queryform.senddir"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="12" v-if="this.pdptdefn === 'AS3'">
        <el-form-item prop="serverout" label="传输发送路径">
          <el-input v-model="queryform.pdserverout"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.pdptdefn === 'AS3'">
        <el-form-item prop="clienttmp" label="传输发送临时路径">
          <el-input v-model="queryform.pdclienttmp"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.pdptdefn === 'AS3'">
        <el-form-item prop="clientmdn" label="传输MDN回执路径">
          <el-input v-model="queryform.pdclientmdn"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.pdptdefn === 'AS2'">
        <el-form-item prop="url" label="请求地址">
          <el-input v-model="queryform.url"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.pdptdefn === 'AS2'">
        <el-form-item prop="as2from" label="发送者ID">
          <el-input v-model="queryform.as2from"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.pdptdefn === 'AS2'">
        <el-form-item prop="as2to" label="接收者ID">
          <el-input v-model="queryform.as2to"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.pdptdefn === 'FTP'">
        <el-form-item prop="senddir" label="传输发送文件夹">
          <el-input v-model="queryform.senddir"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.pdptdefn === 'FTPS'">
        <el-form-item prop="senddir" label="传输发送文件夹">
          <el-input v-model="queryform.senddir"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.pdptdefn === 'SFTP'">
        <el-form-item prop="senddir" label="传输发送文件夹">
          <el-input v-model="queryform.senddir"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.pdptdefn === 'REST'">
        <el-form-item prop="url" label="请求URL">
          <el-input v-model="queryform.url"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.pdptdefn === 'REST'">
        <el-form-item prop="pdtoken" label="token">
          <el-input v-model="queryform.pdtoken"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.pdptdefn === 'REST'">
        <el-form-item prop="contenttype" label="请求类型">
          <el-input v-model="queryform.contenttype"></el-input>
        </el-form-item>
      </el-col>
      <!-- pdptdef动态变化资源结束 -->
    </el-row>
    <el-row>
      <el-collapse v-show="this.queryform.swap_uuid">
        <el-collapse-item>
          <template slot="title">
            性能调优（可选）
            <i class="header-icon el-icon-info"></i>
          </template>
          <template>
            <el-tabs type="border-card">
              <el-alert
                title="注意：性能调优在资源监听重新启动后生效"
                type="info"
                close-text="知道了"
                show-icon
              >
              </el-alert>
              <el-form :model="form" ref="form" label-position="top">
                <el-card class="box-card" title="发送调优">
                  <div slot="header" class="clearfix">
                    <span>性能调优</span>
                    <div class="pull-right">
                      <el-button
                        icon="el-icon-fa-save"
                        title="保存"
                        type="success"
                        plain
                        @click="saveThread()"
                        >保存</el-button
                      >
                    </div>
                  </div>
                  <el-row>
                    <el-col :span="8">
                      <el-form-item label="消费者连接数" prop="sendCsCnnum">
                        <el-input-number
                          v-model="form.sendCsCnnum"
                          :min="1"
                          :max="99"
                          label="消费者连接数"
                        ></el-input-number>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="生产者连接数" prop="sendPdCnnum">
                        <el-input-number
                          v-model="form.sendPdCnnum"
                          :min="1"
                          :max="99"
                          label="生产者连接数"
                        ></el-input-number>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="发送处理线程数 " prop="sendSpNum">
                        <el-input-number
                          v-model="form.sendSpNum"
                          :min="1"
                          :max="99"
                          label="发送处理线程数"
                        ></el-input-number>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-card>
              </el-form>
            </el-tabs>
          </template>
        </el-collapse-item>
      </el-collapse>
    </el-row>

    <!--  RabbitMQ高级配置  -->
    <el-dialog
      close-on-press-escape
      append-to-body
      v-draggable
      :visible.sync="csSenior.rmqshow"
      title="RabbitMQ高级配置"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="dialog-button">
        <el-button
          title="保存"
          class="blue"
          icon="el-icon-fa-save"
          @click="rmqCsResSave()"
          >保存</el-button
        >
      </div>
      <RabbitMQCsRes
        v-if="csSenior.rmqshow"
        ref="rmqcsres"
        :uuid="this.queryform.swap_uuid"
      ></RabbitMQCsRes>
    </el-dialog>
    <el-dialog
      close-on-press-escape
      append-to-body
      v-draggable
      :visible.sync="pdSenior.rmqshow"
      title="RabbitMQ高级配置"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="dialog-button">
        <el-button
          title="保存"
          class="blue"
          icon="el-icon-fa-save"
          @click="rmqPdResSave()"
          >保存</el-button
        >
      </div>
      <RabbitMQPdRes
        v-if="pdSenior.rmqshow"
        ref="rmqpdres"
        :uuid="this.queryform.swap_uuid"
      ></RabbitMQPdRes>
    </el-dialog>
    <!--  AMQ高级配置  -->
    <el-dialog
        close-on-press-escape
        append-to-body
        v-draggable
        :visible.sync="csSenior.amqshow"
        title="AMQ高级配置"
        width="600px"
        :close-on-click-modal="false"
    >
      <div class="dialog-button">
        <el-button
            title="保存"
            class="blue"
            icon="el-icon-fa-save"
            @click="amqCsResSave()"
        >保存</el-button
        >
      </div>
      <AMQCsRes
          v-if="csSenior.amqshow"
          ref="amqcsres"
          :uuid="this.queryform.swap_uuid"
      ></AMQCsRes>
    </el-dialog>
    <el-dialog
        close-on-press-escape
        append-to-body
        v-draggable
        :visible.sync="pdSenior.amqshow"
        title="AMQ高级配置"
        width="600px"
        :close-on-click-modal="false"
    >
      <div class="dialog-button">
        <el-button
            title="保存"
            class="blue"
            icon="el-icon-fa-save"
            @click="amqPdResSave()"
        >保存</el-button
        >
      </div>
      <AMQPdRes
          v-if="pdSenior.amqshow"
          ref="amqpdres"
          :uuid="this.queryform.swap_uuid"
      ></AMQPdRes>
    </el-dialog>
    <!--  IBMMQ高级配置  -->
    <el-dialog
      close-on-press-escape
      append-to-body
      v-draggable
      :visible.sync="csSenior.wmqshow"
      title="IBMMQ高级配置"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="dialog-button">
        <el-button
          title="保存"
          class="blue"
          icon="el-icon-fa-save"
          @click="wmqCsResSave()"
          >保存</el-button
        >
      </div>
      <IBMMQCsRes
        v-if="csSenior.wmqshow"
        ref="wmqcsres"
        :uuid="this.queryform.swap_uuid"
      ></IBMMQCsRes>
    </el-dialog>
    <el-dialog
      close-on-press-escape
      append-to-body
      v-draggable
      :visible.sync="pdSenior.wmqshow"
      title="IBMMQ高级配置"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="dialog-button">
        <el-button
          title="保存"
          class="blue"
          icon="el-icon-fa-save"
          @click="wmqPdResSave()"
          >保存</el-button
        >
      </div>
      <IBMMQPdRes
        v-if="pdSenior.wmqshow"
        ref="wmqpdres"
        :uuid="this.queryform.swap_uuid"
      ></IBMMQPdRes>
    </el-dialog>

    <!--  MSMQ高级配置  -->
    <el-dialog
      close-on-press-escape
      append-to-body
      v-draggable
      :visible.sync="csSenior.msmqshow"
      title="MSMQ高级配置"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="dialog-button">
        <el-button
          title="保存"
          class="blue"
          icon="el-icon-fa-save"
          @click="msmqCsResSave()"
          >保存</el-button
        >
      </div>
      <MSMQCsRes
        v-if="csSenior.msmqshow"
        ref="msmqcsres"
        :uuid="this.queryform.swap_uuid"
      ></MSMQCsRes>
    </el-dialog>
    <el-dialog
      close-on-press-escape
      append-to-body
      v-draggable
      :visible.sync="pdSenior.msmqshow"
      title="MSMQ高级配置"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="dialog-button">
        <el-button
          title="保存"
          class="blue"
          icon="el-icon-fa-save"
          @click="msmqPdResSave()"
          >保存</el-button
        >
      </div>
      <MSMQPdRes
        v-if="pdSenior.msmqshow"
        ref="msmqpdres"
        :uuid="this.queryform.swap_uuid"
      ></MSMQPdRes>
    </el-dialog>

    <!--  DIR高级配置  -->
    <el-dialog
      close-on-press-escape
      append-to-body
      v-draggable
      :visible.sync="csSenior.dirshow"
      title="DIR高级配置"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="dialog-button">
        <el-button
          title="保存"
          class="blue"
          icon="el-icon-fa-save"
          @click="dirCsResSave()"
          >保存</el-button
        >
      </div>
      <DIRCsRes
        v-if="csSenior.dirshow"
        ref="dircsres"
        :uuid="this.queryform.swap_uuid"
      ></DIRCsRes>
    </el-dialog>
    <el-dialog
      close-on-press-escape
      append-to-body
      v-draggable
      :visible.sync="pdSenior.dirshow"
      title="DIR高级配置"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="dialog-button">
        <el-button
          title="保存"
          class="blue"
          icon="el-icon-fa-save"
          @click="dirPdResSave()"
          >保存</el-button
        >
      </div>
      <DIRPdRes
        v-if="pdSenior.dirshow"
        ref="dirpdres"
        :uuid="this.queryform.swap_uuid"
      ></DIRPdRes>
    </el-dialog>

    <!--  AS2高级配置  -->
    <el-dialog
      close-on-press-escape
      append-to-body
      v-draggable
      :visible.sync="csSenior.as2show"
      title="AS2高级配置"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="dialog-button">
        <el-button
          title="保存"
          class="blue"
          icon="el-icon-fa-save"
          @click="as2CsResSave()"
          >保存</el-button
        >
      </div>
      <AS2CsRes
        v-if="csSenior.as2show"
        ref="as2csres"
        :uuid="this.queryform.swap_uuid"
      ></AS2CsRes>
    </el-dialog>
    <el-dialog
      close-on-press-escape
      append-to-body
      v-draggable
      :visible.sync="pdSenior.as2show"
      title="AS2高级配置"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="dialog-button">
        <el-button
          title="保存"
          class="blue"
          icon="el-icon-fa-save"
          @click="as2PdResSave()"
          >保存</el-button
        >
      </div>
      <AS2PdRes
        v-if="pdSenior.as2show"
        ref="as2pdres"
        :uuid="this.queryform.swap_uuid"
      ></AS2PdRes>
    </el-dialog>

    <!--  AS3高级配置  -->
    <el-dialog
      close-on-press-escape
      append-to-body
      v-draggable
      :visible.sync="csSenior.as3show"
      title="AS3高级配置"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="dialog-button">
        <el-button
          title="保存"
          class="blue"
          icon="el-icon-fa-save"
          @click="as3CsResSave()"
          >保存</el-button
        >
      </div>
      <AS3CsRes
        v-if="csSenior.as3show"
        ref="as3csres"
        :uuid="this.queryform.swap_uuid"
      ></AS3CsRes>
    </el-dialog>
    <el-dialog
      close-on-press-escape
      append-to-body
      v-draggable
      :visible.sync="pdSenior.as3show"
      title="AS3高级配置"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="dialog-button">
        <el-button
          title="保存"
          class="blue"
          icon="el-icon-fa-save"
          @click="as3PdResSave()"
          >保存</el-button
        >
      </div>
      <AS3PdRes
        v-if="pdSenior.as3show"
        ref="as3pdres"
        :uuid="this.queryform.swap_uuid"
      ></AS3PdRes>
    </el-dialog>

    <!--  FTP高级配置  -->
    <el-dialog
      close-on-press-escape
      append-to-body
      v-draggable
      :visible.sync="csSenior.ftpshow"
      title="FTP高级配置"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="dialog-button">
        <el-button
          title="保存"
          class="blue"
          icon="el-icon-fa-save"
          @click="ftpCsResSave()"
          >保存</el-button
        >
      </div>
      <FTPCsRes
        v-if="csSenior.ftpshow"
        ref="ftpcsres"
        :uuid="this.queryform.swap_uuid"
      ></FTPCsRes>
    </el-dialog>
    <el-dialog
      close-on-press-escape
      append-to-body
      v-draggable
      :visible.sync="pdSenior.ftpshow"
      title="FTP高级配置"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="dialog-button">
        <el-button
          title="保存"
          class="blue"
          icon="el-icon-fa-save"
          @click="ftpPdResSave()"
          >保存</el-button
        >
      </div>
      <FTPPdRes
        v-if="pdSenior.ftpshow"
        ref="ftppdres"
        :uuid="this.queryform.swap_uuid"
      ></FTPPdRes>
    </el-dialog>

    <!--  FTPS高级配置  -->
    <el-dialog
      close-on-press-escape
      append-to-body
      v-draggable
      :visible.sync="csSenior.ftpsshow"
      title="FTPS高级配置"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="dialog-button">
        <el-button
          title="保存"
          class="blue"
          icon="el-icon-fa-save"
          @click="ftpsCsResSave()"
          >保存</el-button
        >
      </div>
      <FTPSCsRes
        v-if="csSenior.ftpsshow"
        ref="ftpscsres"
        :uuid="this.queryform.swap_uuid"
      ></FTPSCsRes>
    </el-dialog>
    <el-dialog
      close-on-press-escape
      append-to-body
      v-draggable
      :visible.sync="pdSenior.ftpsshow"
      title="FTPS高级配置"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="dialog-button">
        <el-button
          title="保存"
          class="blue"
          icon="el-icon-fa-save"
          @click="ftpsPdResSave()"
          >保存</el-button
        >
      </div>
      <FTPSPdRes
        v-if="pdSenior.ftpsshow"
        ref="ftpspdres"
        :uuid="this.queryform.swap_uuid"
      ></FTPSPdRes>
    </el-dialog>

    <!--  SFTP高级配置  -->
    <el-dialog
      close-on-press-escape
      append-to-body
      v-draggable
      :visible.sync="csSenior.sftpshow"
      title="SFTP高级配置"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="dialog-button">
        <el-button
          title="保存"
          class="blue"
          icon="el-icon-fa-save"
          @click="sftpCsResSave()"
          >保存</el-button
        >
      </div>
      <DIRCsRes
        v-if="csSenior.sftpshow"
        ref="sftpcsres"
        :uuid="this.queryform.swap_uuid"
      ></DIRCsRes>
    </el-dialog>
    <el-dialog
      close-on-press-escape
      append-to-body
      v-draggable
      :visible.sync="pdSenior.sftpshow"
      title="SFTP高级配置"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="dialog-button">
        <el-button
          title="保存"
          class="blue"
          icon="el-icon-fa-save"
          @click="sftpPdResSave()"
          >保存</el-button
        >
      </div>
      <DIRPdRes
        v-if="pdSenior.sftpshow"
        ref="sftppdres"
        :uuid="this.queryform.swap_uuid"
      ></DIRPdRes>
    </el-dialog>
    <el-dialog
      close-on-press-escape
      append-to-body
      v-draggable
      :visible.sync="csSenior.restshow"
      title="REST高级配置"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="dialog-button">
        <el-button
          title="保存"
          class="blue"
          icon="el-icon-fa-save"
          @click="restCsResSave()"
          >保存</el-button
        >
      </div>
      <RESTCsRes
        v-if="csSenior.restshow"
        ref="restcsres"
        :uuid="this.queryform.swap_uuid"
      ></RESTCsRes>
    </el-dialog>
    <el-dialog
        close-on-press-escape
        append-to-body
        v-draggable
        :visible.sync="csSenior.rocketmq"
        title="RocketMQ高级配置"
        width="600px"
        :close-on-click-modal="false"
    >
      <div class="dialog-button">
        <el-button
            title="保存"
            class="blue"
            icon="el-icon-fa-save"
            @click="rocketCsResSave()"
        >保存</el-button
        >
      </div>
      <RocketMQCsRes
          v-if="csSenior.rocketmq"
          ref="rocketcsres"
          :uuid="this.queryform.swap_uuid"
      ></RocketMQCsRes>
    </el-dialog>
    <el-dialog
        close-on-press-escape
        append-to-body
        v-draggable
        :visible.sync="pdSenior.rocketmq"
        title="RocketMQ高级配置"
        width="600px"
        :close-on-click-modal="false"
    >
      <div class="dialog-button">
        <el-button
            title="保存"
            class="blue"
            icon="el-icon-fa-save"
            @click="rocketPdResSave()"
        >保存</el-button
        >
      </div>
      <RocketMQPdRes
          v-if="pdSenior.rocketmq"
          ref="rocketpdres"
          :uuid="this.queryform.swap_uuid"
      ></RocketMQPdRes>
    </el-dialog>
  </el-form>
</template>

<script>
import idApi from '@/api/senior/idApi.js';
import monitorApi from '@/api/senior/monitorApi';
import rApi from '@/api/senior/seniorconf';
import seniorconf from '@/api/senior/seniorconf';
import RabbitMQCsRes from './component/RabbitMQCsRes';
import RabbitMQPdRes from './component/RabbitMQPdRes';
import IBMMQCsRes from './component/IBMMQCsRes';
import IBMMQPdRes from './component/IBMMQPdRes';
import MSMQCsRes from './component/MSMQCsRes';
import MSMQPdRes from './component/MSMQPdRes';
import DIRCsRes from './component/DIRCsRes';
import DIRPdRes from './component/DIRPdRes';
import AS2CsRes from './component/AS2CsRes';
import AS2PdRes from './component/AS2PdRes';
import AS3CsRes from './component/AS3CsRes';
import AS3PdRes from './component/AS3PdRes';
import FTPCsRes from './component/FTPCsRes';
import FTPPdRes from './component/FTPPdRes';
import FTPSCsRes from './component/FTPSCsRes';
import FTPSPdRes from './component/FTPSPdRes';
import SFTPCsRes from './component/SFTPCsRes';
import SFTPPdRes from './component/SFTPPdRes';
import RESTCsRes from './component/RESTCsRes';
import AMQCsRes from './component/AMQCsRes';
import AMQPdRes from "./component/AMQPdRes";
import RocketMQCsRes from './component/RocketMQCsRes';
import RocketMQPdRes from './component/RocketMQPdRes';

let dataDefult = {
  s_config_defn: '',
  s_receiver_defn: '',
  s_sender_conn_uuid: '',
  s_sender_res: '',
  s_rc_uuid: '',
  s_cs_cnnum: '',
  s_cf_uuid: '',
  s_cf_conf: '',
  s_receiver_conn_uuid: '',
  s_receiver_res: '',
  s_charset: '',
  s_msg_type: '',
  ai_uuid: '',
  swap_uuid: '',
  recequeue: '',
  sendqueue: '',
  sendtag:'',
  recetag:'',
  consumerGroup:'',
  producerGroup:'',
  recedir: '',
  senddir: '',
  csserverout: '',
  csclientmdn: '',
  csclienttmp: '',
  pdserverout: '',
  pdclienttmp: '',
  pdclientmdn: '',
  as2from: '',
  as2to: '',
  // REST
  cstoken: '',
  port: 20080,
  reqpath: '/rest/swap',
  ssl: false,
  threshold: 3000,
  maxsize: 4194304,
  url: '',
  pdtoken: '',
  contenttype: 'text/plain',
};
export default {
  components: {
    RabbitMQCsRes,
    RabbitMQPdRes,
    IBMMQCsRes,
    IBMMQPdRes,
    MSMQCsRes,
    MSMQPdRes,
    DIRCsRes,
    DIRPdRes,
    AS2CsRes,
    AS2PdRes,
    AS3CsRes,
    AS3PdRes,
    FTPCsRes,
    FTPPdRes,
    SFTPCsRes,
    SFTPPdRes,
    FTPSCsRes,
    FTPSPdRes,
    idApi,
    RESTCsRes,
    AMQCsRes,
    AMQPdRes,
    RocketMQCsRes,
    RocketMQPdRes
  },
  props: {
    send: '',
  },
  data() {
    return {
      form: {
        sendCsCnnum: '',
        sendPdCnnum: '',
        sendSpNum: '',
      },
      queryform: Object.assign({}, dataDefult),
      options: [],
      rpbOpt: Object,
      routerOpt: Object,
      modelcs: '',
      model: {
        uuid: '',
        type: '',
      },
      recEdi: {
        show: false,
        info: '',
      },
      routerEdi: {
        show: false,
        info: '',
      },
      sendEdi: {
        show: false,
        info: '',
      },
      editor: {
        show: false,
      },
      csptdefn: '',
      pdptdefn: '',
      csSenior: {
        wmqshow: false,
        rmqshow: false,
        dirshow: false,
        msmqshow: false,
        ftpshow: false,
        ftpsshow: false,
        sftpshow: false,
        as2show: false,
        as3show: false,
        restshow: false,
        amqshow:false,
        rocketmq:false,
        form: {},
      },
      pdSenior: {
        wmqshow: false,
        rmqshow: false,
        dirshow: false,
        msmqshow: false,
        ftpshow: false,
        ftpsshow: false,
        sftpshow: false,
        as2show: false,
        as3show: false,
        restshow: false,
        amqshow:false,
        rocketmq:false,
        form: {},
      },
      rules: {
        s_config_defn: [
          { required: true, message: '发送配置标识', trigger: 'blur' },
        ],
        s_receiver_defn: [
          { required: true, message: '接收用户身份', trigger: 'blur' },
        ],
        s_receiver_conn_uuid: [
          { required: true, message: '本地发送协议', trigger: 'blur' },
        ],
        s_rc_uuid: [{ required: true, message: '责任链', trigger: 'blur' }],
        s_sender_res: [
          { required: true, message: '本地发送配置', trigger: 'blur' },
        ],
        s_receiver_res: [
          { required: true, message: '传输发送资源', trigger: 'blur' },
        ],
        s_sender_conn_uuid: [
          { required: true, message: '本地接收协议', trigger: 'blur' },
        ],
        url: [{ required: true, message: '请求URL', trigger: 'blur' }],
      },
    };
  },
  mounted() {
    this.queryform.ai_uuid = this.send.uuid;
    idApi.selectPro().then((respData) => (this.options = respData.connList));
    idApi.selectRpb().then((respData) => (this.rpbOpt = respData.rpbChainList));
    idApi
      .selectRouter()
      .then((respData) => (this.routerOpt = respData.routerTypeList));
    if (this.send.info) {
      idApi
        .InfoSend(this.send.info.uuid, this.send.ai_uuid)
        .then((respData) => {
          this.formatData(respData);
        });
    }
    this.queryThread();
  },
  methods: {
    getSenderRes(conf) {
      var _form = JSON.parse(conf);
      if (this.csptdefn === 'RMQ') {
        this.queryform.recequeue = _form.recequeue;
      }else if (this.csptdefn === 'AMQ') {
        this.queryform.recequeue = _form.recequeue;
      }
      else if (this.csptdefn === 'WMQ') {
        this.queryform.recequeue = _form.recequeue;
      } else if (this.csptdefn === 'DIR') {
        this.queryform.recedir = _form.recedir;
      } else if (this.csptdefn === 'AS2') {
        this.queryform.reqpath = _form.reqpath;
        this.queryform.port = _form.port;
        this.queryform.threshold = _form.threshold;
      } else if (this.csptdefn === 'AS3') {
        this.queryform.csserverout = _form.csserverout;
        this.queryform.csclienttmp = _form.csclienttmp;
        this.queryform.csclientmdn = _form.csclientmdn;
      } else if (this.csptdefn === 'MSMQ') {
        this.queryform.recequeue = _form.recequeue;
      } else if (this.csptdefn === 'FTP') {
        this.queryform.recedir = _form.recedir;
      } else if (this.csptdefn === 'FTPS') {
        this.queryform.recedir = _form.recedir;
      } else if (this.csptdefn === 'SFTP') {
        this.queryform.recedir = _form.recedir;
      } else if (this.csptdefn === 'REST') {
        this.queryform.port = _form.port;
        this.queryform.reqpath = _form.reqpath;
        this.queryform.cstoken = _form.token;
      }else if (this.csptdefn === 'RocketMQ') {
        this.queryform.consumerGroup=_form.consumerGroup;
        this.queryform.recetag=_form.recetag;
        this.queryform.recequeue=_form.recequeue;
      }
    },
    // 赋值字段本地发送资源
    setSenderRes() {
      console.log(2)

      var _form = this.csSenior.form;
      if (this.csptdefn === 'RMQ') {
        _form.recequeue = this.queryform.recequeue;
      }
      else if (this.csptdefn === 'AMQ') {
        _form.recequeue = this.queryform.recequeue;
      }
      else if (this.csptdefn === 'WMQ') {
        _form.recequeue = this.queryform.recequeue;
      } else if (this.csptdefn === 'DIR') {
        _form.recedir = this.queryform.recedir;
      } else if (this.csptdefn === 'AS2') {
        _form.reqpath = this.queryform.reqpath;
        _form.port = this.queryform.port;
        _form.threshold = this.queryform.threshold;
      } else if (this.csptdefn === 'AS3') {
        _form.csserverout = this.queryform.csserverout;
        _form.csclienttmp = this.queryform.csclienttmp;
        _form.csclientmdn = this.queryform.csclientmdn;
      } else if (this.csptdefn === 'MSMQ') {
        _form.recequeue = this.queryform.recequeue;
      } else if (this.csptdefn === 'FTP') {
        _form.recedir = this.queryform.recedir;
      } else if (this.csptdefn === 'FTPS') {
        _form.recedir = this.queryform.recedir;
      } else if (this.csptdefn === 'SFTP') {
        _form.recedir = this.queryform.recedir;
      } else if (this.csptdefn === 'REST') {
        _form.port = this.queryform.port;
        _form.reqpath = this.queryform.reqpath;
        _form.token = this.queryform.cstoken;
      }else if (this.csptdefn === 'RocketMQ') {
        _form.consumerGroup = this.queryform.consumerGroup;
        _form.recetag = this.queryform.recetag;
        _form.recequeue = this.queryform.recequeue;
      }
      this.queryform.s_sender_res = JSON.stringify(_form);
    },
    // 赋值字段传输发送资源
    setRecverRes() {
      console.log(3)
      var _form = this.pdSenior.form;
      if (this.pdptdefn === 'RMQ') {
        _form.sendqueue = this.queryform.sendqueue;
      }
      else if (this.pdptdefn === 'AMQ') {
        _form.sendqueue = this.queryform.sendqueue;
      }
      else if (this.pdptdefn === 'WMQ') {
        _form.sendqueue = this.queryform.sendqueue;
      } else if (this.pdptdefn === 'DIR') {
        _form.senddir = this.queryform.senddir;
      } else if (this.pdptdefn === 'AS2') {
        _form.url = this.queryform.url;
        _form.as2from = this.queryform.as2from;
        _form.as2to = this.queryform.as2to;
      } else if (this.pdptdefn === 'AS3') {
        _form.pdserverout = this.queryform.pdserverout;
        _form.pdclienttmp = this.queryform.pdclienttmp;
        _form.pdclientmdn = this.queryform.pdclientmdn;
      } else if (this.pdptdefn === 'MSMQ') {
        _form.sendqueue = this.queryform.sendqueue;
      } else if (this.pdptdefn === 'FTP') {
        _form.senddir = this.queryform.senddir;
      } else if (this.pdptdefn === 'FTPS') {
        _form.senddir = this.queryform.senddir;
      } else if (this.pdptdefn === 'SFTP') {
        _form.senddir = this.queryform.senddir;
      } else if (this.pdptdefn === 'REST') {
        _form.token = this.queryform.pdtoken;
        _form.url = this.queryform.url;
        _form.contenttype = this.queryform.contenttype;
      }else if (this.pdptdefn === 'RocketMQ') {
        _form.producerGroup = this.queryform.producerGroup;
        _form.sendtag = this.queryform.sendtag;
        _form.sendqueue = this.queryform.sendqueue;
      }
      this.queryform.s_receiver_res = JSON.stringify(_form);
    },
    getRecverRes(conf) {
      console.log(4)
      var _form = JSON.parse(conf);
      if (this.pdptdefn === 'RMQ') {
        this.queryform.sendqueue = _form.sendqueue;
      }
      else if (this.pdptdefn === 'AMQ') {
        this.queryform.sendqueue = _form.sendqueue;
      }
      else if (this.pdptdefn === 'WMQ') {
        this.queryform.sendqueue = _form.sendqueue;
      } else if (this.pdptdefn === 'DIR') {
        this.queryform.senddir = _form.senddir;
      } else if (this.pdptdefn === 'AS2') {
        this.queryform.url = _form.url;
        this.queryform.as2from = _form.as2from;
        this.queryform.as2to = _form.as2to;
      } else if (this.pdptdefn === 'AS3') {
        this.queryform.pdserverout = _form.pdserverout;
        this.queryform.pdclienttmp = _form.pdclienttmp;
        this.queryform.pdclientmdn = _form.pdclientmdn;
      } else if (this.pdptdefn === 'MSMQ') {
        this.queryform.sendqueue = _form.sendqueue;
      } else if (this.pdptdefn === 'FTP') {
        this.queryform.senddir = _form.senddir;
      } else if (this.pdptdefn === 'FTPS') {
        this.queryform.senddir = _form.senddir;
      } else if (this.pdptdefn === 'SFTP') {
        this.queryform.senddir = _form.senddir;
      } else if (this.pdptdefn === 'REST') {
        this.queryform.pdtoken = _form.token;
        this.queryform.url = _form.url;
        this.queryform.contenttype = _form.contenttype;
      }else if (this.pdptdefn === 'RocketMQ') {
         this.queryform.producerGroup=_form.producerGroup;
         this.queryform.sendtag=_form.sendtag;
         this.queryform.sendqueue=_form.sendqueue;
      }
    },
    saveSendConf() {
      console.log(5)
      this.$refs.queryform.validate((valid) => {
        if (valid) {
          this.setSenderRes();
          this.setRecverRes();
          if (this.send.info) {
            idApi.editSendConf(this.queryform).then(() => {
              this.$emit('condSend');
              monitorApi
                .select()
                .then((respData) =>
                  this.$store.dispatch(
                    'client/loadMonTableData',
                    respData.datarows
                  )
                );
            });
          } else {
            idApi.saveSendConf(this.queryform).then(() => {
              this.$emit('condSend');
              monitorApi
                .select()
                .then((respData) =>
                  this.$store.dispatch(
                    'client/loadMonTableData',
                    respData.datarows
                  )
                );
            });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    formatData(val) {
      console.log(6)
      this.queryform.s_config_defn = val.datarows[0].sconfigdefn;
      this.queryform.s_receiver_defn = val.datarows[0].sreceiverdefn;
      this.queryform.s_receiver_conn_uuid = val.datarows[0].sreceiverconnuuid;
      this.queryform.s_receiver_res = val.datarows[0].sreceiverres;
      this.queryform.s_cf_uuid = val.datarows[0].scfuuid;
      this.queryform.s_cf_conf = val.datarows[0].scfconf;
      this.queryform.s_cs_cnnum = val.datarows[0].scscnnum;
      this.queryform.s_msg_type = val.datarows[0].smsgtype;
      this.queryform.s_sender_conn_uuid = val.datarows[0].ssenderconnuuid;
      this.queryform.s_sender_res = val.datarows[0].ssenderres;
      this.queryform.s_rc_uuid = val.datarows[0].srcuuid;
      this.queryform.s_charset = val.datarows[0].scharset;
      this.queryform.swap_uuid = val.datarows[0].sendswapuuid;
      this.queryform.ai_uuid = this.send.ai_uuid;
      this.csSelectChange(this.queryform.s_sender_conn_uuid);
      this.pdSelectChange(this.queryform.s_receiver_conn_uuid);
      this.getRecverRes(this.queryform.s_receiver_res);
      this.getSenderRes(this.queryform.s_sender_res);
    },
    queryThread() {

      if (this.send.info) {
        seniorconf.queryThread(this.send.info.sendswapuuid).then((respData) => {
          this.form.sendCsCnnum = respData.datas.cs_cnnum;
          this.form.sendPdCnnum = respData.datas.pd_cnnum;
          this.form.sendSpNum = respData.datas.sp_num;
        });
      }
    },
    saveThread() {
      console.log(8)
      this.form.sendspuuid = this.queryform.swap_uuid;
      rApi.saveThread(this.form).then(() => {
        this.queryThread();
      });
    },
    csSelectChange(uuid) {

      this.options.forEach((value) => {

        var _uuid = value.id;
        if (_uuid === uuid) {
          console.log(value.ptdefn)
          this.csptdefn = value.ptdefn;
        }
      });
    },
    pdSelectChange(uuid) {
      this.options.forEach((value) => {
        var _uuid = value.id;
        if (_uuid === uuid) {
          this.pdptdefn = value.ptdefn;
        }
      });
    },
    seniorinit() {
      this.csSenior.rocketmq = false;
      this.csSenior.wmqshow = false;
      this.csSenior.rmqshow = false;
      this.csSenior.dirshow = false;
      this.csSenior.msmqshow = false;
      this.csSenior.ftpshow = false;
      this.csSenior.ftpsshow = false;
      this.csSenior.sftpshow = false;
      this.csSenior.as2show = false;
      this.csSenior.as3show = false;
      this.csSenior.restshow = false;
      this.csSenior.amqshow = false;
      this.pdSenior.wmqshow = false;
      this.pdSenior.rmqshow = false;
      this.pdSenior.dirshow = false;
      this.pdSenior.msmqshow = false;
      this.pdSenior.ftpshow = false;
      this.pdSenior.ftpsshow = false;
      this.pdSenior.sftpshow = false;
      this.pdSenior.as2show = false;
      this.pdSenior.as3show = false;
      this.pdSenior.restshow = false;
      this.pdSenior.amqshow = false;
      this.pdSenior.rocketmq = false;
    },
    // 消费者高级选项
    csSelectSenior(uuid) {
      if (this.csptdefn === '' || this.csptdefn === null) {
        this.$message.warning('请选择发送协议！');
        return;
      }
      this.seniorinit();
      if (this.csptdefn === 'RMQ') {
        this.csSenior.rmqshow = true;
      }
      else if (this.csptdefn === 'AMQ') {
        this.csSenior.amqshow = true;
      }
      else if (this.csptdefn === 'WMQ') {
        this.csSenior.wmqshow = true;
      } else if (this.csptdefn === 'DIR') {
        this.csSenior.dirshow = true;
      } else if (this.csptdefn === 'AS2') {
        this.csSenior.as2show = true;
      } else if (this.csptdefn === 'AS3') {
        this.csSenior.as3show = true;
      } else if (this.csptdefn === 'MSMQ') {
        this.csSenior.msmqshow = true;
      } else if (this.csptdefn === 'FTP') {
        this.csSenior.ftpshow = true;
      } else if (this.csptdefn === 'FTPS') {
        this.csSenior.ftpsshow = true;
      } else if (this.csptdefn === 'SFTP') {
        this.csSenior.sftpshow = true;
      } else if (this.csptdefn === 'REST') {
        this.csSenior.restshow = true;
      }  else if (this.csptdefn === 'RocketMQ') {
        this.csSenior.rocketmq = true;
      }
      console.log(this.csSenior.amqshow)
    },
    // 生产者高级选项
    pdSelectSenior(uuid) {
      if (this.pdptdefn === 'REST') return;
      if (this.pdptdefn === '' || this.pdptdefn === null) {
        this.$message.warning('请选择接收协议！');
        return;
      }
      this.seniorinit();
      if (this.pdptdefn === 'RMQ') {
        this.pdSenior.rmqshow = true;
      }
      else if (this.pdptdefn === 'AMQ') {
        this.pdSenior.amqshow = true;
      }
      else if (this.pdptdefn === 'WMQ') {
        this.pdSenior.wmqshow = true;
      } else if (this.pdptdefn === 'DIR') {
        this.pdSenior.dirshow = true;
      } else if (this.pdptdefn === 'AS2') {
        this.pdSenior.as2show = true;
      } else if (this.pdptdefn === 'AS3') {
        this.pdSenior.as3show = true;
      } else if (this.pdptdefn === 'MSMQ') {
        this.pdSenior.msmqshow = true;
      } else if (this.pdptdefn === 'FTP') {
        this.pdSenior.ftpshow = true;
      } else if (this.pdptdefn === 'FTPS') {
        this.pdSenior.ftpsshow = true;
      } else if (this.pdptdefn === 'SFTP') {
        this.pdSenior.sftpshow = true;
      } else if (this.pdptdefn === 'RocketMQ') {
        this.pdSenior.rocketmq = true;
      }
    },
    // rmq消费者保存
    rmqCsResSave() {
      this.csSenior.form = this.$refs.rmqcsres.save();
      this.seniorinit();
    },
    // rmq生产者保存
    rmqPdResSave() {
      this.pdSenior.form = this.$refs.rmqpdres.save();
      this.seniorinit();
    },
    // amq消费者保存
    amqCsResSave() {
      this.csSenior.form = this.$refs.amqcsres.save();
      this.seniorinit();
    },
    // amq生产者保存
    amqPdResSave() {
      this.pdSenior.form = this.$refs.amqpdres.save();
      this.seniorinit();
    },
    wmqCsResSave() {
      this.csSenior.form = this.$refs.wmqcsres.save();
      this.seniorinit();
    },
    wmqPdResSave() {
      this.csSenior.form = this.$refs.wmqpdres.save();
      this.seniorinit();
    },
    msmqCsResSave() {
      this.csSenior.form = this.$refs.msmqres.save();
      this.seniorinit();
    },
    msmqPdResSave() {
      this.csSenior.form = this.$refs.msmqpdres.save();
      this.seniorinit();
    },
    dirCsResSave() {
      this.csSenior.form = this.$refs.dircsres.save();
      this.seniorinit();
    },
    dirPdResSave() {
      this.csSenior.form = this.$refs.dirpdres.save();
      this.seniorinit();
    },
    as2CsResSave() {
      this.csSenior.form = this.$refs.as2csres.save();
      this.seniorinit();
    },
    as2PdResSave() {
      this.csSenior.form = this.$refs.as2pdres.save();
      this.seniorinit();
    },
    as3CsResSave() {
      this.csSenior.form = this.$refs.as3csres.save();
      this.seniorinit();
    },
    as3PdResSave() {
      this.csSenior.form = this.$refs.as3pdres.save();
      this.seniorinit();
    },
    ftpCsResSave() {
      this.csSenior.form = this.$refs.ftpcsres.save();
      this.seniorinit();
    },
    ftpPdResSave() {
      this.csSenior.form = this.$refs.ftppdres.save();
      this.seniorinit();
    },
    ftpsCsResSave() {
      this.csSenior.form = this.$refs.ftpscsres.save();
      this.seniorinit();
    },
    ftpsPdResSave() {
      this.csSenior.form = this.$refs.ftpspdres.save();
      this.seniorinit();
    },
    sftpCsResSave() {
      this.csSenior.form = this.$refs.sftpcsres.save();
      this.seniorinit();
    },
    sftpPdResSave() {
      this.csSenior.form = this.$refs.sftppdres.save();
      this.seniorinit();
    },
    restCsResSave() {
      this.csSenior.form = this.$refs.restcsres.save();
      this.seniorinit();
    },
    rocketCsResSave() {
      this.csSenior.form = this.$refs.rocketcsres.save();
      this.seniorinit();
    },
    rocketPdResSave(){
      this.csSenior.form = this.$refs.rocketpdres.save();
      this.seniorinit();
    },

  },
};
</script>
<style lang="scss">
.lablebtn {
  & .el-form-item__label {
    display: block;
    width: 100%;
    padding: 1px 3px;
  }
}
</style>
